import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles({
  dialog: {
    transition: 'all 0.25s ease-out',
  },
});
